// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"b04cb65f","246":"3c52170a","480":"98989f3c","619":"1bd6ed82","686":"9d9693c1"}[chunkId] + ".chunk.js";
};